import type { FC } from "react";

import { ListItem } from "mds/components/ListItem";
import { LoadingDotsIcon } from "mds/icons";
import { userSelectors } from "store/selectors";
import { sortByFirstName } from "store/selectors/sorting";
import { useListSelector } from "store/store-hooks";
import { compactMap } from "utils/collections";
import { PROFILE_PROPERTIES, getUserFullName } from "utils/user-utils";

interface PreviewUserNamesProps {
  userIds: string[];
  variant?: "inline" | "list";
}

export const PreviewUserNames: FC<PreviewUserNamesProps> = ({ userIds, variant = "inline" }) => {
  const previewUsers = useListSelector(
    (state) =>
      compactMap(userIds, (userId) => userSelectors.selectById(state, userId)).toSorted(
        sortByFirstName,
      ),
    PROFILE_PROPERTIES,
  );

  if (previewUsers.length === 0) {
    return null;
  }

  if (variant === "list") {
    return (
      <>
        {previewUsers.map((user) => (
          <ListItem className="flex w-full items-center" key={user.id}>
            <div className="flex min-w-0 items-center gap-1.5">
              <LoadingDotsIcon className="mx-0.5" size="xs" aria-hidden />
              <div className="body-s min-w-12 overflow-hidden truncate text-black-tint-55">
                {getUserFullName(user)}
              </div>
            </div>
          </ListItem>
        ))}
      </>
    );
  }

  return (
    <>
      {previewUsers.map((user) => (
        <span className="body-xs inline-flex items-center gap-2 text-black-tint-55" key={user.id}>
          <LoadingDotsIcon size="xs" aria-hidden />
          {getUserFullName(user)}
        </span>
      ))}
    </>
  );
};
